"use client";
import Image from "next/image";
import styles from "./styles.module.scss";
import QRCode from "react-qr-code";
import Button from "@components/common/button";
const storeConfig = [
  {
    iconUrl: "https://acko-cms.ackoassets.com/Vector_f6e490d8ef.svg",
    heading: "Download on the",
    name: "App Store",
  },
  {
    iconUrl: "https://acko-cms.ackoassets.com/Group_f827970b06.svg",
    heading: "GET IT ON",
    name: "Google Play",
  },
];
export const ViewMyPassWrapper = () => {
  const handleOnClick = async () => {
    // todo
    window.location.href = "https://ackoapp.onelink.me/TnnH/k3a1b1yq";
  };
  return (
    <div className={styles.viewPageContainer}>
      <div className={styles.viewPassTopContainer}>
        <p className={styles.heading}>
          Delays, cancellations, missed flights.
          <br /> AirPass makes it right.
        </p>
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.appScreenShot}>
          <Image
            className={styles.screenShotImg}
            src="https://acko-cms.ackoassets.com/airpass_dashboard_screenshot_view_8e4fca3c98.webp"
            height={520}
            width={279}
            alt="image"
            priority
          />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.qr}>
            <QRCode className={styles.qrImage} value={"https://ackoapp.onelink.me/TnnH/k3a1b1yq"} size={168} />
          </div>
          <p className={styles.content}>
            AirPass is available on the ACKO app. <span className={styles.bold}>Scan the QR code above</span>
          </p>
          <div className={styles.storeWrapper}>
            {storeConfig.map((store, _idx) => {
              return (
                <div className={styles.storeContainer} key={_idx}>
                  <Image className={styles.img} width={50} height={50} alt="apple-store" src={store.iconUrl} />
                  <div className={styles.nameContainer}>
                    <p className={styles.heading}>{store.heading}</p>
                    <p className={styles.name}>{store.name}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.contentContainerMobile}>
          <p className={styles.content}>AirPass is available on the ACKO app.</p>
          <Button cta="Download the app" onClick={handleOnClick} className={styles.button} />
        </div>
      </div>
    </div>
  );
};
